type ServiceNames =
  | 'user'
  | 'games'
  | 'gwapi'
  | 'subscriptions'
  | 'playback'
  | 'search'
  | 'b2b';

const playbackQueryCodesToServiceNameMapping: Record<string, 'playback'> = {
  WHQ: 'playback',
  WL: 'playback',
  ATWH: 'playback',
  DWH: 'playback',
  UWH: 'playback',
  DFW: 'playback'
};

const searchQueryCodesToServiceNameMapping: Record<string, 'search'> = {
  RMQ: 'search',
  FSCQ: 'search',
  FSCQFBR: 'search',
  PCONTENT: 'search',
  SSQ: 'search',
  SRQ: 'search',
  SLQ: 'search',
  SRRQ: 'search'
};

const b2bQueryCodesToServiceNameMapping: Record<string, 'b2b'> = {
  PS: 'b2b'
};

const gamesQueryCodesToServiceNameMapping: Record<string, 'games'> = {
  HUO: 'games',
  TPAQ: 'games',
  FSTQ: 'games',
  CSTRQ: 'games',
  FWWPSCQ: 'games',
  RUST: 'games',
  SSTA: 'games',
  TQ: 'games',
  MQ: 'games',
  PTQ: 'games',
  COSQ: 'games',
  SCQ: 'games',
  CSQ: 'games',
  SPSQ: 'games',
  LMQ: 'games',
  LCQ: 'games',
  CCI: 'games',
  URQ: 'games',
  GUN: 'games',
  GRI: 'games',
  FWWCQ: 'games',
  PPCQ: 'games',
  PPTQ: 'games',
  CLQ: 'games',
  TLQ: 'games',
  FWWLQ: 'games',
  GZT: 'games',
  CR: 'games'
};

const userQueryCodesToServiceNameMapping: Record<string, 'user'> = {
  UEQ: 'user',
  SOQ: 'user',
  VOQ: 'user',
  VORQ: 'user',
  RATQ: 'user',
  UUDQ: 'user',
  DMLDQ: 'user',
  DMQ: 'user'
};

const gwapiQueryCodesToServiceNameMapping: Record<string, 'gwapi'> = {
  CCQ: 'gwapi',
  FMODQ: 'gwapi',
  FLMDQ: 'gwapi',
  KQ: 'gwapi',
  CQ: 'gwapi',
  FMA: 'gwapi',
  FG: 'gwapi',
  FL: 'gwapi',
  TVSDQ: 'gwapi',
  FEQ: 'gwapi',
  FUNE: 'gwapi',
  FCDDQ: 'gwapi'
};

const subscriptionQueryCodesToServiceNameMapping: Record<
  string,
  'subscriptions'
> = {
  lapserAdvanceRenewalNudge: 'subscriptions'
};

export const QUERY_CODE_TO_SERVICE_NAME_MAPPING: Record<string, ServiceNames> =
  {
    ...playbackQueryCodesToServiceNameMapping,
    ...searchQueryCodesToServiceNameMapping,
    ...b2bQueryCodesToServiceNameMapping,
    ...gamesQueryCodesToServiceNameMapping,
    ...userQueryCodesToServiceNameMapping,
    ...gwapiQueryCodesToServiceNameMapping,
    ...subscriptionQueryCodesToServiceNameMapping
  };
